<template>
  <span>{{ amount === '' ? '' : '￥' + amount }}</span>
</template>

<script>
import { customerMaintainanceAmount } from '@/service/getData'
export default {
  props: {
    customerid: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      amount: '',
    }
  },
  created() {
    if (this.customerid) {
      this.getCustomermaintainanceAmount()
    }
  },
  methods: {
    async getCustomermaintainanceAmount() {
      let res = await customerMaintainanceAmount(this.customerid)
      if (res.code == 0) {
        this.amount = res.data
      }
    },
  },
}
</script>